import React, { useEffect, useState } from "react";
import "./BottomBar.css";
import { useTranslation } from "react-i18next";
import { MdKeyboardDoubleArrowRight } from "react-icons/md";

// BottomBar component definition
function BottomBar() {
  // Destructure the translation function from useTranslation hook
  const { t } = useTranslation("global");
  const [langState, setLangState] = useState(
    localStorage.getItem("lang") || "en"
  ); // Default to 'en' if no lang in localStorage

  useEffect(() => {
    const handleLanguageChange = () => {
      setLangState(localStorage.getItem("lang") || "en");
    };

    window.addEventListener("storage", handleLanguageChange);

    return () => {
      window.removeEventListener("storage", handleLanguageChange);
    };
  }, []);

  useEffect(() => {
    setLangState(localStorage.getItem("lang") || "en");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [localStorage.getItem("lang")]);
  return (
    <footer className="bottombar">
      <div className="btm-top">
        <div>
          <div className="btnv-title-container">
            <img
              className="btnv-logo"
              src={process.env.PUBLIC_URL + "/Assets/logo/Sundari.png"}
              alt="Sundari" // Sundari logo
            />
            <div
              className={`btnv-title ${
                langState === "bn" ? "bangla-font" : ""
              }`}
            >
              {t("navbar.title")}
            </div>{" "}
            {/* Translated title */}
          </div>
          <div className="desc">
            Sundori simplifies plant species identification in the Sundarbans.
            Just upload a photo, and our app will promptly reveal its species.{" "}
            {/* Description of the app */}
          </div>
        </div>
        <div className="btm-link-cont">
          <h5>Quick Navigation</h5>
          <nav className="btm-links">
            {/* Map over the links array and create navigation links */}
            {[
              "about",
              "faq",
              "tou",
              "contact",
              "userapi",
              "privacy",
              "manual",
            ].map((link) => (
              <a
                href={link}
                key={link}
                className={`btm-link ${
                  langState === "bn" ? "bangla-font" : ""
                }`}
              >
                <MdKeyboardDoubleArrowRight className="btm-icon" />{" "}
                {/* Icon for the links */}
                {t(`btm-navbar.${link}`)} {/* Translated link text */}
              </a>
            ))}
          </nav>
        </div>
        <div className="app-store-links">
          <h5>Download Mobile App</h5>
          <div className="btm-pic-container">
            <a
              href="https://apps.apple.com/app/sundori/id6756233242"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src={process.env.PUBLIC_URL + "Assets/logo/appstore.png"}
                alt="App Store"
                className="app-store-icon" // App Store icon
              />
            </a>
            <a
              href="https://play.google.com/store/apps/details?id=net.latechnologies.sundori&pcampaignid=web_share"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src={process.env.PUBLIC_URL + "Assets/logo/playstore.png"}
                alt="Play Store"
                className="app-store-icon" // Play Store icon
              />
            </a>
          </div>
        </div>
        <div className="btm-btm">
          <h5>In Association with</h5>
          <div className="btm-img-container">
            <a href="https://ictd.gov.bd/">
              <img
                src={process.env.PUBLIC_URL + "/Assets/logo/ict.png"}
                alt="ict1"
              />
            </a>
            <a href="http://www.gameapp.gov.bd">
              <img
                src={process.env.PUBLIC_URL + "/Assets/logo/ict2.png"}
                alt="ict2"
              />
            </a>
          </div>
        </div>
      </div>
      <div className="image-container">
        <div className={`copyright ${langState === "bn" ? "bangla-font" : ""}`}>
          {t("btm-navbar.sample")}
        </div>{" "}
        {/* Translated copyright text */}
        <img
          style={{ width: "100%", marginTop: "-60px" }}
          src="Assets/logo/scenery_black.png"
          alt=".." // Background image
        />
      </div>
    </footer>
  );
}

export default BottomBar; // Export the BottomBar component
